import React from 'react'

import { Icon, Check } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { node, number, oneOfType, string } from 'prop-types'

import formatPlanPrice from '../../Utils/formatPlanPrice'
import translatePlansRestructure from '../../Utils/translatePlansRestructure'
import SubscriberStatus from '../SubscriptionPurchase/SubscriberStatus/SubscriberStatus'

function IncludedPurchase({ price = null, plan, formatsCount = 0, actions = null }) {
  const noteKey = formatsCount > 1 ? 'included_note' : 'included_note_without_formats'

  return (
    <>
      <div className="pricing-area__content pricing-area__content--purchase">
        <SubscriberStatus productPrice={formatPlanPrice(price)} isRestructure />
      </div>
      {actions}
      <p className="pricing-area__included-note cgt-caption">
        <Icon svgComponent={Check} size="tiny" notSpaced className="pricing-area__included-note-icon" />
        {translatePlansRestructure(noteKey, { count: formatsCount, plan })}
      </p>
    </>
  )
}

IncludedPurchase.propTypes = {
  price: oneOfType([number, string]),
  plan: string.isRequired,
  formatsCount: number,
  actions: node,
}

export default IncludedPurchase
